import { createFluentVue } from 'fluent-vue'

export default defineNuxtPlugin((nuxtApp) => {
  const { bundles } = useCurrentLocale()
  const fluent = createFluentVue({ bundles: bundles() })
  nuxtApp.vueApp.use(fluent)
})
